module.exports = __webpack_public_path__ + "static/media/guarantee-product-2.c06184dd.png";